/**
 * Cores dos quadrantes do Genius (BR), no sentido horário a partir do topo:
 * vermelho (12h) → verde (3h) → amarelo (6h) → azul (9h).
 *
 * Grade 2×2 (ordem DOM):
 * [0 vermelho] [1 verde]
 * [3 azul]     [2 amarelo]
 */
export const GENIUS_PANEL_SLOT_COUNT = 4;

export type GeniusPanelSlotIndex = 0 | 1 | 2 | 3;

export interface GeniusPanelSlotStyle {
  slot: GeniusPanelSlotIndex;
  cssClass: string;
  labelKey: string;
}

export const GENIUS_PANEL_SLOTS: readonly GeniusPanelSlotStyle[] = [
  { slot: 0, cssClass: 'genius-panel-tile--slot-red', labelKey: 'red' },
  { slot: 1, cssClass: 'genius-panel-tile--slot-green', labelKey: 'green' },
  { slot: 2, cssClass: 'genius-panel-tile--slot-yellow', labelKey: 'yellow' },
  { slot: 3, cssClass: 'genius-panel-tile--slot-blue', labelKey: 'blue' },
] as const;

export function geniusPanelSlotClass(slotIndex: number): string {
  return GENIUS_PANEL_SLOTS[slotIndex]?.cssClass ?? 'genius-panel-tile--slot-red';
}
